var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es240.js.map
